
import { type UserLang } from "Lang";
import { Role } from "shared/Api/Role";
import { type GradeLevel } from "shared/Api/GradeLevel";


export function UserLangGradeShort(userLang: UserLang, gradeLevelId: number|string|GradeLevel): string {
	switch (Number(gradeLevelId)) {
		case 1:
			return userLang.GRADE_SHORT_PK();
		case 2:
			return userLang.GRADE_SHORT_KG();
		case 3:
			return userLang.GRADE_SHORT_FIRST();
		case 4:
			return userLang.GRADE_SHORT_SECOND();
		case 5:
			return userLang.GRADE_SHORT_THIRD();
		case 6:
			return userLang.GRADE_SHORT_FOURTH();
		case 7:
			return userLang.GRADE_SHORT_FIFTH();
		case 8:
			return userLang.GRADE_SHORT_SIXTH();
		case 9:
			return userLang.GRADE_SHORT_SEVENTH();
		case 10:
			return userLang.GRADE_SHORT_EIGHTH();
		case 11:
			return userLang.GRADE_SHORT_NINTH();
		case 12:
			return userLang.GRADE_SHORT_TENTH();
		case 13:
			return userLang.GRADE_SHORT_ELEVENTH();
		case 14:
			return userLang.GRADE_SHORT_TWELFTH();
		case 20:
			return userLang.GRADE_SHORT_NONE();
	}
	return `UNKNOWN-${gradeLevelId}`;
}

export function UserLangGrade(userLang: UserLang, gradeLevelId: number|string|GradeLevel): string {
	switch (Number(gradeLevelId)) {
		case 1:
			return userLang.GRADE_PK();
		case 2:
			return userLang.GRADE_KG();
		case 3:
			return userLang.GRADE_FIRST();
		case 4:
			return userLang.GRADE_SECOND();
		case 5:
			return userLang.GRADE_THIRD();
		case 6:
			return userLang.GRADE_FOURTH();
		case 7:
			return userLang.GRADE_FIFTH();
		case 8:
			return userLang.GRADE_SIXTH();
		case 9:
			return userLang.GRADE_SEVENTH();
		case 10:
			return userLang.GRADE_EIGHTH();
		case 11:
			return userLang.GRADE_NINTH();
		case 12:
			return userLang.GRADE_TENTH();
		case 13:
			return userLang.GRADE_ELEVENTH();
		case 14:
			return userLang.GRADE_TWELFTH();
		case 20:
			return userLang.GRADE_NONE();
	}
	return `UNKNOWN-${gradeLevelId}`;
}

export function UserLangRole(userLang: UserLang, role: Role): string {
	switch (role) {
		case Role.STUDENT:
			return userLang.ROLE_STUDENT();
		case Role.BUILDING_ADMIN:
			return userLang.ROLE_BUILDING_ADMIN();
		case Role.DISTRICT_ADMIN:
			return userLang.ROLE_DISTRICT_ADMIN();
		case Role.FACULTY:
			return userLang.ROLE_FACULTY();
	}
	return `UNKNOWN-${role}`;
}
